import * as _ from "lodash"

import Model from "../../model"
import { EditableProjectFields, ID } from "../../types"
import Command, { CommandName } from "../command"

export type SetProjectFieldsCommandState = {
  id: ID
  fields: EditableProjectFields
  captured?: {
    prevFields: EditableProjectFields
  }
}

export default class SetProjectFieldsCommand extends Command {
  name: CommandName = "set-project-fields"
  state: SetProjectFieldsCommandState

  constructor(state: SetProjectFieldsCommandState) {
    super()
    this.state = _.cloneDeep(state)
  }

  // Possible conflicts:
  //   - project might have been deleted (Cancel)
  //   - goal might have been deleted (Resolve, Cancel)
  //   - ideas might have been deleted (Resolve, Cancel)
  resolveConflicts(model: Model): SetProjectFieldsCommandState | null {
    if (!model.getProject(this.state.id)) return null

    const newState = _.cloneDeep(this.state)
    if (newState.fields.goalId && !model.getGoal(newState.fields.goalId))
      delete newState.fields.goalId

    if (newState.fields.ideaIds) {
      const newIdeaIds = newState.fields.ideaIds.filter((id) =>
        model.getIdea(id)
      )
      if (newIdeaIds.length === 0) delete newState.fields.ideaIds
      else newState.fields.ideaIds = newIdeaIds
    }

    if (Object.keys(newState.fields).length === 0) return null
    return newState
  }

  local(model: Model): any {
    const prevFields = {} as EditableProjectFields
    const project = model.fetchProject(this.state.id)
    for (const key in this.state.fields) {
      prevFields[key] = project[key]
    }
    this.state.captured = { prevFields }
    model.setProjectFields(this.state.id, this.state.fields)
  }

  undo(): Command[] {
    if (!this.state.captured) throw new Error("No captured undo state")
    return [
      new SetProjectFieldsCommand({
        id: this.state.id,
        fields: this.state.captured.prevFields,
      }),
    ]
  }
}
